module.exports = __webpack_public_path__ + "static/media/23.5d8f0b78.mp3";